import * as React from "react";
import { forwardRef } from "react";
const SvgPlusIcon = (props, ref) => /* @__PURE__ */ React.createElement("svg", { fill: "none", height: 24, viewBox: "0 0 24 24", width: 24, xmlns: "http://www.w3.org/2000/svg", ref, ...props }, /* @__PURE__ */ React.createElement("path", { d: "m12 5v14m-7-7h14", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: 1.7 }));
const ForwardRef = forwardRef(SvgPlusIcon);
export default ForwardRef;
